// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__M8bRI","control":"ContactForm_control__iBjpk","actions":"ContactForm_actions__hkpyh"};